import { Http } from './';
import { Config } from '../types';

const logOut = () => Http.get<Config>('node/admin/logout', false);

export {
  logOut,
};
